module.exports = __webpack_public_path__ + "media/images/author/author-11-3284a1207e833b2ad6e3859c1219eac7.jpg";